import React, { useState } from "react";
import PeriodRow from "./PeriodRow";

export default function WeeklyPayrollView({ data }) {
  const info = data.document_info;
  const periods = data.periods || [];

  const [expanded, setExpanded] = useState(new Set());

  const toggleAll = (open) => {
    open
      ? setExpanded(new Set(periods.map(p => p.id)))
      : setExpanded(new Set());
  };

  const toggleOne = (id) => {
    setExpanded(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <>
      <br />

      {/* HEADER */}
      <div className="p-3 bg-[#5a6db3] text-white font-semibold">
        Payroll Statement Details
      </div>

      {/* INFO */}
      <div className="grid grid-cols-2 gap-6 bg-white border rounded-b-lg p-4 shadow">
        <div>
          <h4 className="font-semibold mb-2">Company Information</h4>
          <p><b>Company:</b> {info.company_name}</p>
          <p><b>Currency:</b> {info.currency}</p>
          <p><b>Employees:</b> {info.total_employees}</p>
          <p><b>Frequency:</b> {info.pay_frequency}</p>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Document Information</h4>
          <p><b>Filename:</b> {info.filename}</p>
          <p><b>Uploaded:</b> {info.upload_date}</p>
          <p><b>Status:</b> {info.processing_status}</p>
          <p><b>Method:</b> {info.extraction_method}</p>
        </div>
      </div>

      {/* PERIOD TABLE */}
      <div className="bg-white border shadow mt-6">
        {/* HEADER + ACTIONS */}
        <div className="flex justify-between items-center px-4 py-3 bg-[#5a6db3] text-white">
          <span className="font-semibold">
            Period Summaries ({periods.length})
          </span>

          <div className="flex gap-2">
            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(true)}
            >
              ▼ Expand All
            </button>

            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(false)}
            >
              ▶ Collapse All
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm border-collapse">
            <thead className="bg-gray-100 sticky top-0 z-20">
              <tr>
                <Th w={140}>Period</Th>
                <Th w={120}>End Date</Th>
                <Th w={90}>Emp</Th>

                <Th w={140} align="right">Gross</Th>
                <Th w={140} align="right">Taxable</Th>
                <Th w={140} align="right">NIC-able</Th>

                <Th w={120} align="right">Tax</Th>
                <Th w={140} align="right">Emp NICs</Th>
                <Th w={180} align="right">Loans</Th>

                <Th w={140} align="right">Net</Th>
                <Th w={160} align="right">Take-home</Th>

                <Th w={140} align="right">Er NICs</Th>
                <Th w={160} align="right">Er Pension</Th>

                <Th w={160} align="right">Total Cost</Th>
                <Th w={90} align="center">View</Th>
              </tr>
            </thead>

            <tbody className="divide-y">
              {periods.map(p => (
                <PeriodRow
                  key={p.id}
                  period={p}
                  isOpen={expanded.has(p.id)}
                  onToggle={() => toggleOne(p.id)}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

/* =================== TABLE HEADER =================== */

const Th = ({ children, w, align = "left" }) => (
  <th
    style={{ minWidth: w }}
    className={`px-3 py-2 border text-${align} whitespace-nowrap`}
  >
    {children}
  </th>
);
